import { configureStore } from "@reduxjs/toolkit";
import Data_Base from '../Redux/reducers';


const store = configureStore({
    reducer: Data_Base,
});

export default store;